import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LandingRoutingModule } from "./landing-routing.module";
import { LandingComponent } from "./landing.component";
import { ComponentsModule } from '../../components/components.module';
import { PerfectScrollbarModule } from "ngx-om-perfect-scrollbar";
import { MatIconModule } from "@angular/material/icon";
import { NgApexchartsModule } from "ng-apexcharts";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTabsModule } from "@angular/material/tabs";
import { NgxGaugeModule } from "ngx-gauge";
import { BarRatingModule } from "ngx-bar-rating";
import { MatDialogModule } from "@angular/material/dialog";
import { NgbModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef } from "@angular/material/bottom-sheet";

@NgModule({
  imports: [
    CommonModule,
    LandingRoutingModule,
    ComponentsModule,
    PerfectScrollbarModule,
    MatIconModule,
    MatTabsModule,
    MatDialogModule,
    NgbModule,
    NgbCollapseModule,
    MatBottomSheetModule
  ],
  declarations: [LandingComponent],
  providers: [
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} }
  ],
})
export class LandingModule { }
